import { render, staticRenderFns } from "./TheChainChooser.vue?vue&type=template&id=50a757fd"
import script from "./TheChainChooser.vue?vue&type=script&lang=js"
export * from "./TheChainChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports